/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/Palm_wind.glb -o src/models/plants/PalmWind.jsx --transform --draco 
Files: public/Palm_wind.glb [7.02MB] > /Users/radek/Documents/GIthub/CoffeeCoded/coffeecoded/src/models/plants/assets/plants/Palm_wind-transformed.glb [357.73KB] (95%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import modelUrl from '../../assets/plants/Palm_wind-transformed.glb'

export function Model(props) {
  const { nodes, materials } = useGLTF(modelUrl)
  return (
    <group {...props} dispose={null}>
      <group rotation={[Math.PI / 2, 0, -2.756]} scale={0.01}>
        <mesh geometry={nodes.BezierCurve055.geometry} material={materials.PalmTrunk} />
        <mesh geometry={nodes.BezierCurve055_1.geometry} material={materials.PalmLeaves} />
      </group>
    </group>
  )
}

useGLTF.preload(modelUrl)
